import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { parseXyToRgbValue } from '../ActuatorControl/components/ColorRGBControl/utils';
import CustomTooltip from '../shared/atoms/CustomTooltip';

const ColorReading = ({ value, width, height }) => {
  const rgbValue = parseXyToRgbValue(value);
  const rgbString = `rgb(${rgbValue.r}, ${rgbValue.g}, ${rgbValue.b})`;

  return (
    <CustomTooltip title={rgbString}>
      <Box
        sx={{
          background: `${rgbString} !important`,
          width,
          height,
          borderRadius: '8px',
          border: '3px solid #fff',
          boxShadow:
            '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
        }}
      />
    </CustomTooltip>
  );
};

ColorReading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ColorReading;
